import { Icon, Popover, Position, Tag } from "@blueprintjs/core"
import { ID } from "src/libs/interfaces/layouts"
import { getContrastColor } from "src/libs/utilities"
import { ILanding, ILandingCategory } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"


export interface IChildrenCategoriesProps {
    cat: ILandingCategory
    categories:  ID[]
    onClick: (cat: ILandingCategory) => void
    level: number
}

export const ChildrenCategories = ({cat, categories, onClick, level, ...props}: IChildrenCategoriesProps): JSX.Element => {
    const currentLanding: ILanding  = useLandingStore( (state: ILandingStore) => state.currentLanding )
    const is = !categories.length || categories.find( ( id: ID ) => id === cat.id )
    const children = currentLanding.categories?.filter(c => c.parentId === cat.id) || []
    return <Tag 
        style={{ 
            backgroundColor: is ? cat.color : "transparent", 
            border: `1px solid ${ cat.color }`,
            cursor : is ? undefined : "pointer"
        }} 
        className="d-flex p-0"
        key={ cat.id } 
    >
        <span className="d-flex align-items-center w-100 justify-content-between">
            <span className="smallest letter-spacing-2 px-2 py-0" style={{ color: is ? getContrastColor( cat.color ) : cat.color }} onClick={ () => onClick(cat) }>
                { cat.title }
            </span>
            {
                !!children.length &&
                <Popover
                    interactionKind="hover"
                    position={ level === 0 ? Position.BOTTOM : Position.RIGHT_TOP }
                    content={
                        <div className="p-0">
                            <div className="d-flex flex-column align-items-between">
                                {
                                    children.map(ch => {
                                        return <ChildrenCategories
                                            key={ch.id}
                                            cat={ch}
                                            categories={categories}
                                            level={level + 1}
                                            onClick={onClick}
                                        />
                                    })
                                }
                            </div>
                        </div>
                    }                    
                    modifiers={{
                        arrow: { enabled: false },
                        flip: { enabled: true },
                        preventOverflow: { enabled: false },
                    }}
                >
                    <div className="px-2 d-flex align-items-center pointer">
                        <Icon icon="caret-down" size={11} color={ is ? getContrastColor( cat.color ) : cat.color } />
                    </div>
                </Popover>
            }
        </span>
    </Tag>
}
